import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { DeviceType } from '@era/locations-sdk';
import { getDevicesCountFilteredOnSubset, getDevicesFilteredOnSubset } from '@era/stores';
import { NgbDropdownButtonItem, NgbDropdownItem, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContextMenuComponent } from '@rocksoft/cdk';
import { environment } from '@rocksoft/environment';
import { Device, EnvironmentFeatures } from '@rocksoft/shared';
import { RebootDevicesModalContainerComponent } from '../../sub-features/reboot-devices-modal/reboot-devices-modal.container';
import { DeviceGridComponent } from '../device-grid/device-grid.component';
import { DevicesSyncModalContainerComponent } from '../modals/devices-sync-modal/devices-sync-modal.container';
import { DeviceLocationSubsetConfig } from './device-location-subset.config';

@Component({
  selector: 'era-devices-location-subset',
  templateUrl: './devices-location-subset.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DeviceGridComponent, ContextMenuComponent, NgbDropdownButtonItem, NgbDropdownItem, AsyncPipe],
})
export class DevicesLocationSubsetContainerComponent implements OnInit {
  private readonly deviceStore = inject(Store);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly modalService = inject(NgbModal);

  public readonly config = input.required<DeviceLocationSubsetConfig>();

  public readonly features: EnvironmentFeatures = environment.features;
  public devices$!: Observable<Device[]>;
  public devicesCount$!: Observable<number>;

  ngOnInit(): void {
    // Use existing utility functions with locationSubset from config
    this.devices$ = getDevicesFilteredOnSubset(this.deviceStore, this.config().locationSubset);
    this.devicesCount$ = getDevicesCountFilteredOnSubset(this.deviceStore, this.config().locationSubset);
  }

  public itemSelected(device: Device): void {
    if (device.deviceType === DeviceType.Apple && device.udid) {
      void this.router.navigate(['apple', device.udid], { relativeTo: this.route });
    }
  }

  public openRebootRequest(): void {
    const modal = this.modalService.open(RebootDevicesModalContainerComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modal.componentInstance.locationSubset = this.config().locationSubset;
  }

  public openSyncModalRequest(): void {
    const modal = this.modalService.open(DevicesSyncModalContainerComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modal.componentInstance.locationSubset = this.config().locationSubset;
  }
}
